<!--
 * A Vue component that wraps the b-button element of Bootstrap Vue.
 *
 * Properties
 * ==========
 * - id -
 * (Optional) The text that is used as id for element.
 *
 * - name -
 * (Optional) The text that is used as name for element.
 *
 * - text -
 * (Optional) The text to show on the button.
 *
 * Events
 * ==========
 * - click -
 * This event is sent when user clicks the button.
 *
-->

<template>
    <div id="base-button-container">
        <b-button v-bind="$attrs" :id="id" :name="name" @click="$_onclick">
            {{ text }} <span v-if="iconClass" :class="iconClass"></span>
        </b-button>
    </div>
</template>

<script>
    export default {
        inheritAttrs: false,
        name: 'base-button',
        props: {
            id: { type: String, default: 'base-button-id' },
            name: { type: String, default: 'base-button-name' },
            text: { type: String, default: '' },
            iconClass: { type: String, default: '' }
        },

        methods: {
            $_onclick: function () {
                this.$emit('click');
            }
        }
    };
</script>
